"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMortgageCommonState = void 0;
var SfilterPriceCustomOption_init_1 = require("@/pages/common/states/sfilter/sections/price/SfilterPriceCustomOption.init");
var MortgageTab_1 = require("@/pages/detail/states/MortgageTab");
var MortgageArticle_init_1 = require("@/pages/mortagage/states/MortgageArticle.init");
var MortgageCommonTranslate_init_1 = require("@/pages/mortagage/states/MortgageCommonTranslate.init");
var MortgageRateTableInputs_init_1 = require("@/pages/mortagage/states/MortgageRateTableInputs.init");
var MortgageLimitTable_init_1 = require("@okay/okay-mortgage/src/states/MortgageLimitTable.init");
var MortgageInsuranceTable_init_1 = require("@okay/okay-mortgage/src/states/MortgageInsuranceTable.init");
exports.defaultMortgageCommonState = {
    t: MortgageCommonTranslate_init_1.defaultMortgageCommonTranslate,
    menuActive: false,
    hasOutstandingMortgage: false,
    searchForSaleRanges: {
        from: SfilterPriceCustomOption_init_1.defaultSfilterPriceCustomOptionBuyHkd.from.map(function (it) { return it.value; }),
        to: SfilterPriceCustomOption_init_1.defaultSfilterPriceCustomOptionBuyHkd.to.map(function (it) { return it.value; }),
    },
    mortgageTab: MortgageTab_1.MortgageTab.OVERVIEW,
    rateTableYears: [5, 10, 15, 20, 25, 30],
    backgroundImage: '/res/img/skyline_hk.jpg',
    adValoremStampDutyRate: 15,
    buyerStampDutyRate: 15,
    commissionRate: 1,
    stressTestRateIncrease: 3,
    stressTestMinIncomePercentageNonStressed: 50,
    stressTestMinIncomePercentageStressed: 50,
    downPayment: 0,
    propertyValue: 0,
    articles: MortgageArticle_init_1.defaultMortgageArticles,
    articleActiveIndex: -1,
    doubleAdValoremStampDutyRateTable: [
        { value: 21739120, k: 0, m: 0, r: 4.25 },
        { value: 20000000, k: 750000, m: 20000000, r: 10 },
        { value: 10080000, k: 0, m: 0, r: 3.75 },
        { value: 9000000, k: 270000, m: 9000000, r: 10 },
        { value: 6642860, k: 0, m: 0, r: 3 },
        { value: 6000000, k: 135000, m: 6000000, r: 10 },
        { value: 4935480, k: 0, m: 0, r: 2.25 },
        { value: 4500000, k: 67500, m: 4500000, r: 10 },
        { value: 3528240, k: 0, m: 0, r: 1.5 },
        { value: 3000000, k: 100, m: 3000000, r: 10 },
        { value: 0, k: 100, m: 0, r: 0 }
    ],
    specialStampDutyRateTable: [
        { month: 6, r: 20 },
        { month: 12, r: 15 },
        { month: 36, r: 10 },
    ],
    mortgageInsuranceSetting: MortgageInsuranceTable_init_1.defaultMortgageInsuranceTableCounterCycle,
    mortgageInsuranceSettingWithProperty: MortgageInsuranceTable_init_1.defaultMortgageInsuranceTableCounterCycleWithProperty,
    mortgageLimitTable: MortgageLimitTable_init_1.defaultMortgageLimitTable,
    isResultVisible: false,
    isInsuranceMonthlyRepay: true,
    legalAmount: 10000,
    rateTableInputs: MortgageRateTableInputs_init_1.defaultMortgageRateTableInput,
};
